import { ReactElement } from "react";
import { IIconProps } from "../types";

export default function IconGlobe({ color, size }: IIconProps): ReactElement {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height={size || 14}
      width={size || 14}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        d="M7 1C7 1.5 6 2.5 6.5 3C7.29057 3.79057 8.82054 2.89728 8.5 4.5C8 7 12.5 6.5 13 6.5C10 8 9.5 11 11 12M2.5 2.5C2.5 2.5 3.5 3 4 4.5C4.5 6 0.5 7.5 0.5 7.5M1.5 10C1.5 10 5.5 7.5 6.5 8.5C7.5 9.5 5.59692 12.0689 5 13"
        stroke="#5A6072"
      />
      <circle cx="7" cy="7" r="6.5" stroke={color || "#5A6072"} />
    </svg>
  );
}
